import { useTranslation } from "@redotech/redo-i18n";
import ArrowRightIcon from "@redotech/redo-icons/arrow-right.svg";
import XCloseIcon from "@redotech/redo-icons/x-close.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import * as darkModeCss from "@redotech/redo-web/theme/component-colors-dark.module.css";
import { memo } from "react";

/**
 * Bottom-right "Resume <Product>" chip shown outside the product's routes while intake is pending.
 * The intake modal is route-scoped, so this routes the merchant back to it.
 */
export const WidgetResumeReminder = memo(function WidgetResumeReminder({
  displayName,
  onClick,
  onDismiss,
}: {
  displayName: string;
  onClick: () => void;
  onDismiss: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Flex
      align="center"
      bgColor="primary"
      borderRadius="md"
      className={darkModeCss.darkMode}
      gap="xs"
      p="xs"
    >
      <RedoButton
        hierarchy="tertiary"
        IconTrailing={ArrowRightIcon}
        onClick={onClick}
        size="sm"
        text={t("Resume {{product}}", { product: displayName })}
      />
      <RedoButton
        aria-label={t("Hide setup reminder")}
        hierarchy="tertiary"
        IconLeading={XCloseIcon}
        onClick={onDismiss}
        size="xs"
      />
    </Flex>
  );
});
